import React, { createContext, useContext, useState, useCallback } from "react";

const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BASE_URL =
    process.env.REACT_APP_CONFIG_API_URL?.trim() ||
    "https://devapi.fiduciaai.in";

  const fetchConfig = useCallback(
    async (customerKey, ocid) => {
      setLoading(true);
      setError(null);
      try {
        // First API call
        const response1 = await fetch(
          `${BASE_URL}/cebackendapi/getCameraAIConfig`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ customerkey: customerKey, ocid: ocid }),
          }
        );

        if (!response1.ok) {
          throw new Error("Failed to fetch Camera AI Config");
        }

        let data = await response1.json();

        // Fallback to OpenAI Config if title is not present
        if (!data?.userData?.title) {
          const response2 = await fetch(
            `${BASE_URL}/cebackendapi/getOpenAIConfig`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ customerkey: customerKey, ocid: ocid }),
            }
          );

          if (!response2.ok) {
            throw new Error("Failed to fetch OpenAI Config");
          }

          data = await response2.json();
        }

        setConfig(data);
      } catch (err) {
        console.error("Error fetching config:", err);
        setError(err.message || "Failed to fetch config");
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL]
  );

  return (
    <ConfigContext.Provider value={{ config, loading, error, fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
